import {
  Modal,
  Form,
  DatePicker,
  Select,
  Input,
  Row,
  Col,
  message,
} from "antd";
import { createRelance } from "../../api/prospections";

export default function ModalRelance({ open, onClose, prospection, onSuccess }) {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      await createRelance(prospection.id, {
        date_relance: values.date_relance.format("YYYY-MM-DD"),
        canal: values.canal,
        commentaire: values.commentaire,
      });

      message.success("Relance créée avec succès");
      form.resetFields();
      onSuccess();
      onClose();
    } catch (e) {
      message.error("Erreur lors de la création de la relance");
    }
  };

  return (
    <Modal
      title={`Créer une relance – ${prospection?.objet || ""}`}
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okText="Créer la relance"
      width={650}
    >
      <Form
        form={form}
        layout="horizontal"
        style={{ width: "100%" }}
      >
        <Row
          gutter={16}
          align="middle"
          justify="start"
          style={{ width: "100%", marginBottom: 12 }}
        >
          <Col span={6} style={{ textAlign: "right", fontWeight: 500 }}>
            Date de relance :
          </Col>
          <Col span={16}>
            <Form.Item
              name="date_relance"
              rules={[{ required: true, message: "Date obligatoire" }]}
              noStyle
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>

        <Row
          gutter={16}
          align="middle"
          justify="start"
          style={{ width: "100%", marginBottom: 12 }}
        >
          <Col span={6} style={{ textAlign: "right", fontWeight: 500 }}>
            Canal :
          </Col>
          <Col span={16}>
            <Form.Item
              name="canal"
              rules={[{ required: true, message: "Canal obligatoire" }]}
              noStyle
            >
              <Select 
                placeholder="Sélectionner un canal"
                style={{ width: "100%" }}  
              >
                <Select.Option value="TELEPHONE">📞 Téléphone</Select.Option>
                <Select.Option value="EMAIL">✉️ Email</Select.Option>
                <Select.Option value="WHATSAPP">💬 WhatsApp</Select.Option>
                <Select.Option value="VISITE">🏢 Visite</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row
          gutter={16}
          align="top"
          justify="start"
          style={{ width: "100%" }}
        >
          <Col span={6} style={{ textAlign: "right", fontWeight: 500 }}>
            Commentaire :
          </Col>
          <Col span={16}>
            <Form.Item name="commentaire" noStyle>
              <Input.TextArea
                rows={4}
                placeholder="Ex : Client intéressé, à relancer après validation interne"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

    </Modal>
  );
}
